import React from 'react';

const Modal = (props) => {
    return (
        <div className={"modal fade " + props.options.show} tabIndex="-1" role="dialog">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Agregar saldo</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={props.cerrarModal()}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="form-group">
                            <label htmlFor="">Monto</label>
                        <input type="text" name="saldo" id="saldo" className="form-control" value={props.options.saldo || ""}
                            onChange={props.handleChanges()} />
                        </div>
                        <div className="form-group mt-3">
                            <label htmlFor="">Comentario</label>
                            <textarea name="comentario" className="form-control" id="comentario" rows="5" onChange={props.handleChanges()} defaultValue={props.options.comentario || ""}></textarea>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={props.cerrarModal()}>Cancelar</button>
                        <button type="button" className="btn btn-primary" onClick={props.guardarSaldo(props.options.uindex)}>Guardar saldo</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;


// WEBPACK FOOTER //
// ./src/components/Modal.js